import { BASE_PATH as h, BaseAPI as l, operationServerMap as d } from "../base.js";
import { DUMMY_BASE_URL as O, assertParamExists as b, createRequestFunction as u, setSearchParams as v, toPathString as R } from "../common.js";
import A from "axios";
var L = function(e) {
  return { merchantMemberOptionRecordGetMerchantMemberOperationList: async (a, o = {}) => {
    b("merchantMemberOptionRecordGetMerchantMemberOperationList", "query", a);
    const n = new URL("/merchant_member_option_record/list", O);
    let r;
    e && (r = e.baseOptions);
    const t = {
      method: "GET",
      ...r,
      ...o
    }, i = {}, c = {};
    if (a !== void 0) for (const [m, p] of Object.entries(a)) c[m] = p;
    v(n, c);
    let s = r && r.headers ? r.headers : {};
    return t.headers = {
      ...i,
      ...s,
      ...o.headers
    }, {
      url: R(n),
      options: t
    };
  } };
}, M = function(e) {
  const a = L(e);
  return { async merchantMemberOptionRecordGetMerchantMemberOperationList(o, n) {
    var r, t;
    const i = await a.merchantMemberOptionRecordGetMerchantMemberOperationList(o, n), c = (r = e == null ? void 0 : e.serverIndex) !== null && r !== void 0 ? r : 0, s = (t = d["MerchantMemberOptionRecordApi.merchantMemberOptionRecordGetMerchantMemberOperationList"]) === null || t === void 0 || (t = t[c]) === null || t === void 0 ? void 0 : t.url;
    return (m, p) => u(i, A, h, e)(m, s || p);
  } };
}, V = function(e, a, o) {
  const n = M(e);
  return { merchantMemberOptionRecordGetMerchantMemberOperationList(r, t) {
    return n.merchantMemberOptionRecordGetMerchantMemberOperationList(r.query, t).then((i) => i(o, a));
  } };
}, S = class extends l {
  merchantMemberOptionRecordGetMerchantMemberOperationList(e, a) {
    return M(this.configuration).merchantMemberOptionRecordGetMerchantMemberOperationList(e.query, a).then((o) => o(this.axios, this.basePath));
  }
};
export {
  S as MerchantMemberOptionRecordApi,
  L as MerchantMemberOptionRecordApiAxiosParamCreator,
  V as MerchantMemberOptionRecordApiFactory,
  M as MerchantMemberOptionRecordApiFp
};

//# sourceMappingURL=merchant-member-option-record-api.js.map